import { Dispatch } from 'react';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import getFlagValue from '../../utils/getFlagValue';
import {
  addQueueCouponServiceCount,
  resetQueueCouponServiceCount,
} from '../../../store/emarsys/action';
import { PAGE_NAME_SERVICE_COUPON } from '../../../constants/emarsys/service-coupon';

export default function eventClickCouponServiceList(
  dispatch: Dispatch<any>,
  carCategory: string,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  customerNo: string,
  sectionName: string,
  buttonName: string,
  newParams?: Record<string, string | number | boolean>
) {
  const isFlagActive = getFlagValue('EMARSYS');
  if (!isFlagActive) return;
  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: PAGE_NAME_SERVICE_COUPON.COUPON_SERVICE_LISTING_PAGE,
    page_title: pageTitle,
    page_url: window.location.href,
    section_name: sectionName,
    button_name: buttonName,
  };
  if (breadcrumbItems?.[1]?.name) {
    valueClickAction.menu_cat_lvl1 = breadcrumbItems?.[1]?.name?.toLowerCase();
  }
  if (breadcrumbItems?.[2]?.name) {
    valueClickAction.menu_cat_lvl2 = breadcrumbItems?.[2]?.name?.toLowerCase();
  }
  if (breadcrumbItems?.[3]?.name) {
    valueClickAction.menu_cat_lvl3 = breadcrumbItems?.[3]?.name?.toLowerCase();
  }
  if (carCategory) {
    valueClickAction.car_category = carCategory.toLowerCase();
  }
  if (newParams?.car_model) {
    valueClickAction.car_model = newParams?.car_model;
  }
  if (newParams?.order_by) {
    valueClickAction.order_by = newParams?.order_by;
  }
  if (newParams?.search) {
    valueClickAction.search = newParams?.search;
  }
  if (newParams?.special_offer) {
    valueClickAction.special_offer = newParams?.special_offer;
  }
  ScarabQueue.push(['tag', 'click_button', valueClickAction]);
  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    dispatch(resetQueueCouponServiceCount());
  } else {
    dispatch(addQueueCouponServiceCount());
  }
}
